import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface StyleProps {
  ready?: boolean
  filled?: boolean
  small?: boolean
  flag?: string
  mandatory?: boolean
  error?: string
}

export const FileInput = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  height: 48px;
  width: 315px;
  max-width: 315px;
  padding: 12px 16px;
  box-sizing: border-box;
  border-radius: 5px;
  border: ${(props: StyleProps) => {
    if (props.error) return '1px solid #f60665'
    if (props.filled) return `none`
    if (props.mandatory) return `2px dashed ${Theme.pallete.SENARY}`
    if (props.ready) return `2px dashed #DF7A58`
    return `2px dashed ${Theme.pallete.QUATERNARY}`
  }};
  background-color: ${(props: StyleProps) => {
    if (props.filled) return '#DF7A58 '
    return Theme.pallete.SECONDARY4
  }};
  cursor: pointer;
  .hide-input {
    display: none;
  }
  #upload-text {
    color: ${(props: StyleProps) => {
      if (props.filled) return Theme.pallete.PRIMARY
      return Theme.pallete.QUATERNARY2
    }};
    font-size: 12px;
    font-weight: 400;
    margin-left: 30px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
  }
`
export const Ancor = styled.div`
  position: relative;
  width: 315px;
  margin: 16px 0;
`
export const FileImage = styled.img`
  position: absolute;
  width: 24px;
  height: 24px;
  filter: ${(props: StyleProps) => {
    if (props.filled) return 'none'
    if (props.mandatory)
      return 'invert(12%) sepia(95%) saturate(5126%) hue-rotate(357deg) brightness(106%) contrast(115%)'
    if (props.ready)
      return 'invert(56%) sepia(48%) saturate(693%) hue-rotate(337deg) brightness(95%) contrast(93%);'
    return 'invert(81%) sepia(12%) saturate(11%) hue-rotate(37deg) brightness(100%) contrast(93%)'
  }};
`

export const TextInput = styled.input`
  font-weight: 500;
  font-size: 16px;
  color: ${Theme.pallete.PRIMARY};
  caret-color: ${Theme.pallete.TERTIARY};
  cursor: pointer;
  &::placeholder {
    color: ${Theme.pallete.QUATERNARY};
  }
  border: none;
  outline: none;
  max-width: 100%;
  background: none;
`

export const FileName = styled.p`
  font-size: 16px;
  font-weight: 500;
  text-align: left;
`

export const Subtitle = styled.p`
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  color: ${Theme.pallete.QUATERNARY2};
  margin: 0 0 8px 0;
`

export const Underlined = styled.p`
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  margin-right: 1ch;
  text-decoration: underline;
`

export const GreyInfo = styled.p`
  font-size: ${(props: StyleProps) => {
    if (props.small) return '10px'
    return '12px'
  }};
  font-weight: 400;
  text-align: left;
  color: ${Theme.pallete.QUATERNARY};
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

export const Flag = styled.div`
  font-size: 10px;
  font-weight: 400;
  text-align: left;
  padding: 2px 6px;
  border-radius: 5px;
  margin-left: 10px;
  color: ${Theme.pallete.SECONDARY};
  background-color: ${(props: StyleProps) => {
    if (props.flag === 'SIGNED') return Theme.pallete.QUINARY
    return Theme.pallete.SENARY
  }};
`

export const ActionIcon = styled.img`
  margin-left: 10px;
  width: 12px;
  height: 12px;
  cursor: pointer;
`
export const InputError = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  padding: 5px 20px;
  width: 215px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #f60665;
`
